module.exports = __webpack_public_path__ + "img/ceo.fa84ffa9.png";